__turbopack_context__.v({
  "body": "FoodServiceLanding-module-scss-module__TMCzBG__body",
  "fade-in": "FoodServiceLanding-module-scss-module__TMCzBG__fade-in",
  "heading": "FoodServiceLanding-module-scss-module__TMCzBG__heading",
  "hero": "FoodServiceLanding-module-scss-module__TMCzBG__hero",
  "image": "FoodServiceLanding-module-scss-module__TMCzBG__image",
});
